/**
 * Portuguese Common Translations
 * 通用翻译模块 - 葡萄牙语
 * 
 * 包含导航栏 (nav) 和页脚 (footer) 的翻译
 */

import type { CommonTranslations } from '../../types';

export const ptCommon: CommonTranslations = {
  nav: {
    home: 'Início',
    products: 'Produtos',
    technology: 'Tecnologia',
    about: 'Sobre Nós',
    contact: 'Contato',
    faq: 'Perguntas Frequentes',
  },
  footer: {
    contact: 'Contate-nos',
    phone: 'Telefone',
    email: 'E-mail',
    address: 'Endereço',
    rights: 'Todos os direitos reservados.',
    brandDesc: 'Fabricante profissional de aquecedores radiantes infravermelhos desde 2006, dedicado a fornecer soluções de aquecimento quentes, confortáveis e eficientes para todo o mundo.',
    products: 'Produtos',
    support: 'Suporte',
    newsletter: 'Fique Atualizado',
    newsletterDesc: 'Inscreva-se para receber as últimas atualizações de produtos e notícias do setor.',
    join: 'Participar',
    catalog: 'Baixar Catálogo',
    emailPlaceholder: 'Digite seu e-mail',
    product1: 'Aquecedor de Infravermelho',
    product2: 'Aquecedor Portátil',
    product3: '',
    product4: '',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Serviço',
    sitemap: 'Mapa do Site',
    installationGuide: 'Guia de Instalação',
    warrantyPolicy: 'Política de Garantia',
  },
};
